<template>
    <v-container fluid>
        <v-app-bar app color="white">
            <v-img src="../../images/fishbone-logo.jpg" :min-width="isMobile ? 100 : 900" class="mr-4 logo" />
            <v-spacer></v-spacer>
            <v-btn :href="'/Dashboard'" color="primary" class="mr-3">
                <v-icon left>mdi-logout</v-icon> {{ $t('Enfermedadesadd.regresar') }}
            </v-btn>
        </v-app-bar>

        <v-btn color="primary" class="mt-4" @click="abrirFormularioNuevo">
            {{ $t('Enfermedadesadd.agregar') }}
        </v-btn>
        <v-data-table :headers="headers" :items="enfermedades" dense class="mt-4" :mobile-breakpoint="600">
            <template v-slot:item.acciones="{ item }">
                <v-btn color="blue" small icon @click="editarEnfermedad(item)">
                    <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn color="red" small icon @click="confirmarEliminar(item.id)">
                    <v-icon>mdi-delete</v-icon>
                </v-btn>
            </template>
        </v-data-table>

        <!-- Modal Agregar/Editar -->
        <v-dialog v-model="dialogAgregar" :fullscreen="isMobile" scrollable>
            <v-card>
                <v-card-title>{{ editando ? 'Editar' : 'Agregar' }} Enfermedad</v-card-title>
                <v-card-text>
                    <v-form ref="form">
                        <v-text-field v-model="form.enfermedad" :label="$t('Enfermedadesadd.nombre')" />
                        <v-textarea v-model="form.descripcion" :label="$t('Enfermedadesadd.descripcion')" />
                        <v-textarea v-model="form.tratamiento" :label="$t('Enfermedadesadd.tratamiento')" />
                        <v-text-field v-model="form.sup_enfermedad" :label="$t('Enfermedadesadd.idEnfermedadSup')"
                            type="number" />
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" @click="guardarEnfermedad">{{ $t('app.save') }}</v-btn>
                    <v-btn @click="dialogAgregar = false">{{ $t('app.cancel') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Modal Confirmar Eliminar -->
        <v-dialog v-model="dialogEliminar" max-width="400px">
            <v-card>
                <v-card-title>{{ $t('Enfermedadesadd.eliminarEnf') }}</v-card-title>
                <v-card-text>{{ $t('Enfermedadesadd.advertencia') }}</v-card-text>
                <v-card-actions>
                    <v-btn color="red" @click="eliminarEnfermedad">{{ $t('Enfermedadesadd.eliminar') }}</v-btn>
                    <v-btn @click="dialogEliminar = false">{{ $t('app.cancel') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import axios from "axios";
const apiUrl = process.env.VUE_APP_API_URL;

export default {
    data() {
        return {
            enfermedades: [],
            dialogAgregar: false,
            dialogEliminar: false,
            editando: false,
            idEliminar: null,
            form: {
                enfermedad: "",
                descripcion: "",
                tratamiento: "",
                sup_enfermedad: null,
            },
            headers: [
                { text: "Identificador", value: "id" },
                { text: "Enfermedad", value: "enfermedad" },
                { text: "Descripción", value: "descripcion" },
                { text: "Tratamiento", value: "tratamiento" },
                { text: "Superior", value: "sup_enfermedad" },
                { text: "Acciones", value: "acciones", sortable: false },
            ],
        };
    },
    computed: {
        isMobile() {
            return this.$vuetify.display.mdAndDown;
        },
    },
    methods: {
        abrirFormularioNuevo() {
            this.form = {
                enfermedad: "",
                descripcion: "",
                tratamiento: "",
                sup_enfermedad: null,
            };
            this.editando = false;
            this.dialogAgregar = true;
        },
        async cargarEnfermedades() {
            const res = await axios.get(`${apiUrl}/api/enfermedades/`);
            this.enfermedades = res.data;
        },
        editarEnfermedad(item) {
            this.form = { ...item };
            this.editando = true;
            this.dialogAgregar = true;
        },
        async guardarEnfermedad() {
            if (this.editando) {
                await axios.put(`${apiUrl}/api/enfermedades/update/${this.form.id}`, this.form);
            } else {
                await axios.post(`${apiUrl}/api/enfermedades/create`, this.form);
            }
            this.dialogAgregar = false;
            this.editando = false;
            this.cargarEnfermedades();
        },
        confirmarEliminar(id) {
            this.idEliminar = id;
            this.dialogEliminar = true;
        },
        async eliminarEnfermedad() {
            await axios.delete(`${apiUrl}/api/enfermedades/delete/${this.idEliminar}`);
            this.dialogEliminar = false;
            this.cargarEnfermedades();
        },
    },
    mounted() {
        this.cargarEnfermedades();
    },
};
</script>

<style scoped>
.logo {
    max-height: 50px;
}
</style>
